var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStitchedRectangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149 42.5V50h7.499v5H146.5c-1.325 0-2.41-1.032-2.495-2.336L144 52.5v-10h5zm30 7.5v5h-15.001v-5H179zm20-7.5v10c0 1.38-1.12 2.5-2.5 2.5h-10v-5h7.5v-7.5h5zM149 20v15h-5V20h5zm50 0v15h-5V20h5zm-2.5-20c1.38 0 2.5 1.12 2.5 2.5v10h-5V5h-7.5V0zm-40 0v5H149v7.5h-5v-10c0-1.325 1.032-2.41 2.336-2.494L146.5 0h10zM179 5h-15V0h15v5z",
    transform: "translate(-162 -356) translate(1 104) translate(17 252.2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStitchedRectangle);
export default __webpack_public_path__ + "static/media/stitched-rectangle.55c9e5e1.svg";
export { ForwardRef as ReactComponent };